import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { Auth } from 'aws-amplify';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { DataGridContainer } from '../../../Episode/Episode.Styled';
import {
  CBP_CASE_MANAGER_DETAIL,
  CBP_CASE_MANAGER_LIST,
  dateFormat,
} from '../../../../constants';
import { getStopApi } from '../../../../services/StopApi/StopApi';
import {
  getCbpCaseManagerForm,
  newCaseManager,
} from '../../../../redux/cbp/cbpCaseManager/cbpCaseManagerSlice';
import CBPCaseManagerDialog from './CBPCaseManagerDialog';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import { ButtonGrid } from '../../../ui/styled';

const CBPCaseManagerList = (props) => {
  const dispatch = useDispatch();
  const cbpId = useSelector((state) => state.cbpForm?.cboID);
  const [user, setUser] = useState(null);
  const [openCBPCaseManagerDialog, setOpenCBPCaseManagerDialog] =
    useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [cbpCaseManager, setCBPCaseManager] = useState({
    isLoading: false,
    data: [],
    total: 0,
    page: 1,
    pageSize: 10,
  });

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken && cbpId) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [
    user?.signInUserSession.accessToken.jwtToken,
    cbpCaseManager.pageSize,
    cbpCaseManager.page,
    cbpId
  ]);

  const fetchData = async () => {
    setCBPCaseManager((prveState) => ({ ...prveState, isLoading: true }));
    const commonParams = `${CBP_CASE_MANAGER_LIST}/${cbpId}/casemanager/list?PageNumber=${cbpCaseManager.page}&PageSize=${cbpCaseManager.pageSize}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    getStopApi({ commonParams, authorization }).then((response) => {
      const json = response.data;
      setCBPCaseManager((prveState) => ({
        ...prveState,
        isLoading: false,
        total: response.totalRows,
        data: json?.map((item, index) => ({
          ...item,
          id: item.CbpCmID ? item.CbpCmID : '-',
          caseManager: item.caseManager?.value ? item.caseManager?.value : '-',
          referralType: item.referralType?.athTypId
            ? item.referralType?.athTypId
            : '-',
          startDate: item.startDate
            ? moment(item.startDate).format(dateFormat).split('T')[0]
            : '-',
          endDate: item.endDate
            ? moment(item.endDate).format(dateFormat).split('T')[0]
            : '-',
          CbpCmID: item.CbpCmID ? item.CbpCmID : '-',
        })),
      }));
    }).catch((e) => alert(e));
  };

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const updateCBPCaseManagerDialog = (params) => {
    const cbpCaseManagerUrl = `${CBP_CASE_MANAGER_DETAIL}/${params.id}`;
    const authorization = user?.signInUserSession.accessToken.jwtToken;
    setOpenCBPCaseManagerDialog(true);
    setOpenBackdrop(true);
    setTimeout(() => {
      setOpenBackdrop(false);
    }, 600);
    dispatch(getCbpCaseManagerForm({ cbpCaseManagerUrl, authorization }));
  };

  const openNewCaseManager = () => {
    const caseManagerNewList = {
      newCbpCaseManager: true,
      CbpCmID: 0,
      caseManager: '',
      referralType: '',
      startDate: '',
      endDate: '',
    };
    dispatch(newCaseManager(caseManagerNewList));
    setOpenCBPCaseManagerDialog(true);
  };

  const columnsData = [
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 1,
      type: 'actions',
      renderCell: (params) => {
        return (
          <IconButton onClick={() => updateCBPCaseManagerDialog(params)}>
            <EditIcon />
          </IconButton>
        );
      },
    },
    {
      field: 'caseManager',
      headerName: 'Case Manager',
      sortable: false,
      flex: 1,
    },
    {
      field: 'referralType',
      headerName: 'Referral Type',
      sortable: false,
      flex: 1,
    },
    {
      field: 'startDate',
      headerName: 'Start Date',
      type: 'date',
      sortable: false,
      flex: 1,
    },
    {
      field: 'endDate',
      headerName: 'End Date',
      type: 'date',
      sortable: false,
      flex: 1,
    },
    {
      field: 'CbpCmID',
      headerName: 'CBPCmId',
      sortable: false,
      flex: 1,
    },
  ];

  return (
    <>
      <Grid container>
        <ButtonGrid item xs={12}>
          <Button variant='contained' onClick={() => openNewCaseManager()}>
            New Case Manager
          </Button>
        </ButtonGrid>
        <Grid item xs={12}>
          <DataGridContainer>
            <DataGrid
              getRowHeight={() => 'auto'}
              columns={columnsData}
              rows={cbpCaseManager.data}
              page={cbpCaseManager.page - 1}
              rowCount={cbpCaseManager.total}
              rowsPerPageOptions={[10, 25, 50]}
              pageSize={cbpCaseManager.pageSize}
              pagination
              paginationMode='server'
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
              }
              onPageSizeChange={(newPageSize) =>
                setCBPCaseManager((prveState) => ({
                  ...prveState,
                  pageSize: newPageSize,
                }))
              }
              onPageChange={(newPage) => {
                setCBPCaseManager((prveState) => ({
                  ...prveState,
                  page: newPage + 1,
                }));
              }}
              loading={cbpCaseManager.isLoading}
              //onRowClick={(param) => cbpCaseManagerRowClick(param.row)}
              disableColumnFilter
              disableColumnMenu
            />
          </DataGridContainer>
        </Grid>
      </Grid>
      <CBPCaseManagerDialog
        open={openCBPCaseManagerDialog}
        setOpen={setOpenCBPCaseManagerDialog}
        openBackdrop={openBackdrop}
        cbpId={cbpId}
        authToken={user?.signInUserSession.accessToken.jwtToken}
        fetchData={fetchData}
      />
    </>
  );
};
export default CBPCaseManagerList;
